const openingDate = () => {
  const currentDate = /* @__PURE__ */ new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const twoDigitMonth = month.toString().padStart(2, "0");
  const twoDigitDay = day.toString().padStart(2, "0");
  return `${year}-${twoDigitMonth}-${twoDigitDay}`;
};
export {
  openingDate
};
